<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Réinitialisation du mot de passe</h4>
                                    <p>Remplissez le formulaire pour reinitialiser votre mot de passe.</p>
                                </div>
                                <vs-input type="email" label-placeholder="Email"
                                    :danger="!!formErrors.vector"
                                    :danger-text="formErrors.vector ? formErrors.vector[0] : ''"
                                 v-model="email" class="w-full mb-6" />
                                 <vs-input type="text" label-placeholder="Code reçu par mail"
                                    :danger="!!formErrors.reset_code"
                                    :danger-text="formErrors.reset_code ? formErrors.reset_code[0] : ''"
                                  v-model="reset_code" class="w-full mb-6" />
                                <vs-input type="password" label-placeholder="Nouveau mot de passe"
                                    :danger="!!formErrors.password"
                                    :danger-text="formErrors.password ? formErrors.password[0] : ''"
                                     v-model="password" class="w-full mb-6" />
                                <vs-input type="password" label-placeholder="Confirmer le mot de passe"
                                    :danger="!!formErrors.confirm_password"
                                    :danger-text="formErrors.confirm_password ? formErrors.confirm_password[0] : ''"
                                 v-model="confirm_password" class="w-full mb-8" />

                                <!--div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row"-->
                                     <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Retour à la connexion</vs-button>
                                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" @click="submitData" :disabled="!isFormValid">Réinitialiser</vs-button>
                                <!--/div-->

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import axios from "@/axios.js"

export default {
    data() {
        return {
            email: '',
            reset_code: '',
            password: '',
            confirm_password: '',
            formErrors: []
        }
    },
    computed:{

        isFormValid() {
      return (
        !this.errors.any() && this.email && this.reset_code && this.password && this.confirm_password 
      );
    }
    },
    methods:{

        submitData(){     
            this.$vs.loading()                   
            axios.post('/auth/password/reset',{vector:this.email, reset_code:this.reset_code, password:this.password, password_confirmation:this.confirm_password})
            .then((response) => {
                
                this.$vs.loading.close()
                this.$router.push('/login').catch(() => {})
          
                //console.log(response.data)
                
                this.$vs.notify({
                    title: 'Succès',
                    text: response.data.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                })
            })
        .catch((error) => { 

        //    window.getApp.error(error)
            
            // console.log('madaliou: ', error, '//////////////////////////////////////////////////')
            // console.log() 
            this.$vs.loading.close()
            this.$vs.notify({
                title: 'Erreur',
                text: this.formErrors = error.response.data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            })
            this.formErrors = error.response.data.errors;
        })
        }
    }
}
</script>
